// extracted by mini-css-extract-plugin
module.exports = {"overlay":"global-loader_overlay__Aw81L","spinner":"global-loader_spinner__1QmO6"};